import React from 'react';
import { Provider } from "react-redux";
import UserProvider from "./providers/user-provider";
import store from "./redux/store";
import { AuthenticatedAdmin } from './components/admin/';
import AppHeader from './components/app-header';
import './app.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

export default function App() {
  return (
		<Provider store={store}>
		    <Router>
		        <Switch>
		          <Route path="/">
								<div className="app admin-app-wrap">
									<AppHeader />
									<UserProvider>
										<AuthenticatedAdmin />
									</UserProvider>
								</div>
		          </Route>
		        </Switch>
		    </Router>
		</Provider>
  );
}
